import { render, staticRenderFns } from "./LandingPageComponent.vue?vue&type=template&id=370effb4&scoped=true"
import script from "./LandingPageComponent.vue?vue&type=script&lang=js"
export * from "./LandingPageComponent.vue?vue&type=script&lang=js"
import style0 from "./LandingPageComponent.vue?vue&type=style&index=0&id=370effb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370effb4",
  null
  
)

export default component.exports